// extracted by mini-css-extract-plugin
module.exports =  {"color-picker-container":"color-picker-container-Cny5U"};